// src/context/auth/authContext.js
import { createContext } from "react";

const AuthContext = createContext();

export default AuthContext;